import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useSEO } from '../hooks/useSEO';

export default function PartnerDashboard() {
    useSEO(
        'Panel Partnera — PickOneGift',
        'Zarządzaj swoimi integracjami, sprawdzaj analitykę dodanych do list prezentów i rośnij razem z PickOneGift.'
    );

    return (
        <div className="page">
            <Header />
            <div className="container" style={{ padding: '48px 24px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
                    <div>
                        <h1 style={{ fontSize: '2rem', marginBottom: '8px' }}>Panel Analityczny (Wersja Demo)</h1>
                        <p className="text-muted">Przykładowe dane integracji z widgetem PickOneGift dla Twojego sklepu.</p>
                    </div>
                    <Link to="/demo" className="btn btn-secondary">
                        <span style={{ marginRight: '8px' }}>👀</span> Zobacz widget na stronie Demo
                    </Link>
                </div>

                {/* KPI Cards */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px', marginBottom: '40px' }}>
                    <div className="card glass" style={{ padding: '24px', textAlign: 'center' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '8px' }}>🎁</div>
                        <h3 className="text-muted" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Produkty na listach</h3>
                        <p style={{ fontSize: '2.5rem', fontWeight: 800, background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                            1,432
                        </p>
                        <p className="text-muted" style={{ fontSize: '0.85rem', marginTop: '8px' }}>+12% w stosunku do ubiegłego miesiąca</p>
                    </div>

                    <div className="card glass" style={{ padding: '24px', textAlign: 'center' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '8px' }}>🔗</div>
                        <h3 className="text-muted" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Wygenerowany ruch (kliknięcia)</h3>
                        <p style={{ fontSize: '2.5rem', fontWeight: 800, color: 'var(--color-primary)' }}>
                            8,950
                        </p>
                        <p className="text-muted" style={{ fontSize: '0.85rem', marginTop: '8px' }}>Przez UTM source: pickonegift</p>
                    </div>

                    <div className="card glass" style={{ padding: '24px', textAlign: 'center' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '8px' }}>💰</div>
                        <h3 className="text-muted" style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Szacowana wartość wizyt</h3>
                        <p style={{ fontSize: '2.5rem', fontWeight: 800 }}>
                            14,500 zł
                        </p>
                        <p className="text-muted" style={{ fontSize: '0.85rem', marginTop: '8px' }}>Wartość produktów dodanych do list</p>
                    </div>
                </div>

                {/* Chart Mockup Area */}
                <div className="card glass" style={{ padding: '32px', marginBottom: '40px' }}>
                    <h3 style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span>📈</span> Aktywność z ostatnich 30 dni
                    </h3>
                    <div style={{ 
                        height: '250px', 
                        background: 'rgba(255,255,255,0.02)', 
                        borderRadius: '12px', 
                        display: 'flex', 
                        alignItems: 'flex-end', 
                        padding: '16px',
                        gap: '8px',
                        borderBottom: '1px solid rgba(255,255,255,0.1)'
                    }}>
                        {/* Mock bars */}
                        {[30, 45, 20, 60, 80, 55, 70, 90, 40, 65, 85, 100].map((height, i) => (
                            <div key={i} style={{
                                flex: 1,
                                height: `${height}%`,
                                background: height > 70 ? 'var(--gradient-primary)' : 'rgba(124, 92, 252, 0.4)',
                                borderRadius: '4px 4px 0 0',
                                transition: 'height 0.3s ease'
                            }} />
                        ))}
                    </div>
                </div>

                {/* Top Products */}
                <h3 style={{ marginBottom: '24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span>⭐</span> Najczęściej dodawane produkty
                </h3>
                <div style={{ display: 'grid', gap: '16px' }}>
                    {[
                        { title: 'Słuchawki Noise Cancelling Pro', lists: 342, category: 'Audio' },
                        { title: 'Zestaw Smart Home Start', lists: 215, category: 'Elektronika' },
                        { title: 'Klawiatura Mechaniczna RGB', lists: 198, category: 'Akcesoria IT' },
                    ].map((prod, i) => (
                        <div key={i} className="card glass" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>
                            <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                                <div style={{ 
                                    width: '40px', 
                                    height: '40px', 
                                    background: 'var(--color-primary)', 
                                    borderRadius: '50%', 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'center',
                                    fontWeight: 'bold',
                                    flexShrink: 0
                                }}>
                                    #{i + 1}
                                </div>
                                <div>
                                    <h4 style={{ marginBottom: '4px' }}>{prod.title}</h4>
                                    <span className="text-muted" style={{ fontSize: '0.85rem' }}>{prod.category}</span>
                                </div>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{prod.lists}</div>
                                <div className="text-muted" style={{ fontSize: '0.85rem' }}>Dodań do list</div>
                            </div>
                        </div>
                    ))}
                </div>

                <div style={{ marginTop: '48px', padding: '32px', background: 'rgba(255,255,255,0.03)', borderRadius: '16px', textAlign: 'center' }}>
                    <h2 style={{ marginBottom: '16px' }}>Wdrożenie to zaledwie 5 minut</h2>
                    <p className="text-muted" style={{ maxWidth: '600px', margin: '0 auto 24px' }}>
                        Powyższy panel to wersja demonstracyjna dla sklepów partnerskich. Skontaktuj się z nami, aby włączyć swój sklep i otrzymać kod integracyjny dla widgetu na własnych kartach produktowych.
                    </p>
                    <a href="mailto:contact@pickonegift.net" className="btn btn-primary btn-lg">Rozpocznij współpracę</a>
                </div>

            </div>
            <Footer />
        </div>
    );
}
